<div id="menu-versions">
    <p><strong>{{ 'release_version' | myLbTranslate }}:</strong> {{ applianceDetails.releaseVersion }}</p>
    <p><strong>{{ 'host_name' | myLbTranslate }}:</strong> {{ applianceDetails.hostName }}</p>
    <p>Copyright <span>&copy;</span> {{ companyName }}</p>
</div>

